/* eslint-disable */
import axios from 'axios'

const searchBoxService = {
    getAgentWholesalerId(){
        return new Promise((resolve)=>{
            let data = null;
            axios.post(
                "/api/Go/GetAgentWholesalerId",
                data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });         
    }
}

export default searchBoxService;